<template>
  <div class="container">
    <my-sale-datatable />
  </div>
</template>

<script>
import MySaleDatatable from "./my_sale_datatable/Index.vue";

export default {
  name: "CentralDispatchTrackerMySales",
  components: { MySaleDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {},
    refresh() {},
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
